import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCheckABModal = () => openPopupHelper({ popupName: popupNames.CHECK_AB_MODAL });
